// Single source of truth for Kiri's character artwork. Swap these two paths
// to replace the placeholder character with final production art — nothing
// else in the app needs to change.
export const KIRI_HERO = "/kiri/kiri-hero.png"; // full body, used large (launcher/home)
export const KIRI_AVATAR = "/kiri/kiri-avatar.png"; // head/shoulders, used small (header/messages)
